import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOwnership = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M3.83301 10.4907V8.57874C3.83301 8.30259 4.05687 8.07874 4.33301 8.07874H11.6671C11.9432 8.07874 12.1671 8.30259 12.1671 8.57874V10.4907",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 7.52394L8 5.43481",
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 10.773,
			width: 3.5,
			height: 3.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 6.25,
			y: 1.72699,
			width: 3.5,
			height: 3.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 10.5,
			y: 10.773,
			width: 3.5,
			height: 3.5,
			rx: 1,
			stroke: "currentColor",
			strokeLinecap: "round"
		})
	]
});
export default SvgOwnership;
